import { render } from "./ItemsModal.vue?vue&type=template&id=bd9f11f4&scoped=true"
import script from "./ItemsModal.vue?vue&type=script&lang=js"
export * from "./ItemsModal.vue?vue&type=script&lang=js"

import "./ItemsModal.vue?vue&type=style&index=0&id=bd9f11f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd9f11f4"]])

export default __exports__